import styled from "styled-components";

const FormLabel = styled.label`
    display: block;
    margin-bottom: 10px;

    font-size: 14px;

    color: var(--midle-gray4);
`;

export default FormLabel